export { default as default } from './AfegirBlocFormulariComponent.jsx';